module.exports = __webpack_public_path__ + "static/media/bg-card_warranty-registration.b4ebf957.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg/bg-card_warranty-registration.jpg
// module id = 1500
// module chunks = 0